<template>
  <div class="smart">
    <!-- banner部分 -->
    <div class="smart-banner clearfix">
      <div>
        <h2>智慧校园</h2>
        <h3>校园广播系统</h3>
      </div>
    </div>
    <!-- 方案概述 -->
    <div class="container clearfix">
      <div class="smart-title">方案概述</div>
      <div class="smart-overview">
        <div>
          <h2>校园广播系统</h2>
          <p>IP网络广播系统充分利用数字技术，使用户的操作更加直观、简 易，系统配置更加灵活，功能更加强大。因此，公共广播系统的 更新为数字化系统是必要的，它可以更直观、更方便地解决以往 传统意义公共广播系统无法解决的事，为教学应用提供更多可拓 展的空间。</p>
        </div>
      </div>
    </div>
    <!-- 方案优势 -->
    <div class="container clearfix">
      <div class="smart-title">方案优势</div>
      <ul class="smart-strength clearfix mb100">
        <li>
          <h2>功能强大</h2>
          <p>IP网络广播系统可独立控制每个终端播放不同的内容，实 现模拟音源与数字音源同步输出到指定班级（如：可控制局域网内100个 班级终端同时播放不少于20路模拟音源及不少于100路数字音源）。真 正满足实际应用，并能实现不断扩展；</p>
        </li>
        <li>
          <h2>音质清晰</h2>
          <p>网络传输为数字化、网络化，系统信噪比高，不会在处理、传 输等环节产生噪声，从而可以获得比较好的音质，也可以进行立体声传 输。同时室内终端采用专业音响级别单元，满足对声音质量要求较高的 场合，如高考、大学四六级考试听力播放，及教室里的日常听力训练。每 个发音都可以清晰可辨，不再为含混不清的声音所困扰。</p>
        </li>
        <li>
          <h2>互动性强</h2>
          <p>广播不再局限于单方面的播音,可以实现双向对讲互动，实现 全物联网化管理，在任意地点移动客户端上即可对广播系统实现远程管 理及互动。例如远程讲话、数字音频调节、终端音量调节等。</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SscampuselRadio',
};
</script>
<style scoped>
.smart-banner {
  width: 100%;
  height: 594px;
  background: #000;
}
.smart-banner div {
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: url(../../../assets/img/smart/background_Image.png) no-repeat;
  background-size: cover;
}
.smart-banner h2 {
  margin-top: 182px;
  text-align: center;
  font-size: 100px;
  font-weight: bold;
  color: #fff;
}
.smart-banner h3 {
  text-align: center;
  font-size: 30px;
  font-weight: 400;
  color: #fff;
}
.smart-title {
  width: 100%;
  margin-top: 100px;
  margin-bottom: 100px;
  text-align: center;
  font-size: 60px;
  font-weight: bold;
  color: #000;
}
.smart-overview {
  width: 100%;
  height: 334px;
}
.smart-overview p {
  font-size: 18px;
  font-weight: 400;
  color: #666;
  text-indent: 2em;
  line-height: 1.8;
}
.smart-overview h2 {
  text-align: center;
  margin-bottom: 45px;
  font-size: 24px;
  font-weight: bold;
  color: #000;
}
.smart-strength {
  display: table;
  margin-right: -132px;
}
.smart-strength li {
  float: left;
  width: 366px;
  height: 280px;
  margin-right: 41px;
  margin-bottom: 50px;
}
.smart-strength li h2 {
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: bold;
  color: #333;
}
.smart-strength li p {
  font-size: 18px;
  font-weight: 400;
  color: #333;
  line-height: 1.6;
}
</style>
